export default "__VITE_ASSET__Cry7lTcT__"